import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { SlideToggleComponent } from '../../../form/controls/slide-toggle/slide-toggle.component';
import { HintComponent } from '../../../hint/hint.component';

@Component({
  selector: 'app-knockout-criteria',
  templateUrl: './knockout-criteria.component.html',
  styleUrls: ['./knockout-criteria.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    HintComponent,
    SlideToggleComponent,
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe
  ]
})
export class KnockoutCriteriaComponent {
  readonly formControlInput = input<FormControl>(undefined);
  readonly disabled = input<boolean>(undefined);
}
